import React from 'react';
import './Products.sass';

import { connect } from 'react-redux';
import cx from 'classnames';

import {
  analyticsClearEcommerce,
  analyticsSelectItem,
  analyticsSelectRelatedItem,
  analyticsSelectSpecialItem,
} from '../../middlewares/analytics/actions';
import ProductItem from "./ProductItem";

@connect()
export default class Products extends React.PureComponent {
  onProductSelect = (taxon, product, index) => {
    const { dispatch, isMainTaxon } = this.props;

    dispatch(analyticsClearEcommerce());
    if (isMainTaxon) {
      dispatch(analyticsSelectSpecialItem(taxon, product, index));
    } else {
      dispatch(analyticsSelectItem(taxon, product, index));
    }
  };

  onRelatedProductSelect = (product, mainProduct, index) => {
    const { dispatch } = this.props;

    dispatch(analyticsClearEcommerce());
    dispatch(analyticsSelectRelatedItem(product, mainProduct, index));
  };

  render() {
    const { taxon, products, three, mainProduct, related, limited } = this.props;

    return (
      <div className={cx('products', three && 'products--three')}>
        {limited && limited.map((product, idx) => (
          <ProductItem
            key={idx}
            onProductSelect={this.onProductSelect}
            onRelatedProductSelect={this.onRelatedProductSelect}
            product={product}
            taxon={taxon}
            idx={idx}
            mainProduct={mainProduct}
            related={related}/>
        ))}
        {Array.isArray(products) ? products.map((product, idx) => (
          <ProductItem
            key={idx}
            onProductSelect={this.onProductSelect}
            onRelatedProductSelect={this.onRelatedProductSelect}
            product={product}
            taxon={taxon}
            idx={idx}
            mainProduct={mainProduct}
            related={related}/>
        )) : Object.values(products).map((product, idx) => (
          <ProductItem
            key={idx}
            onProductSelect={this.onProductSelect}
            onRelatedProductSelect={this.onRelatedProductSelect}
            product={product}
            taxon={taxon}
            idx={idx}
            mainProduct={mainProduct}
             related={related}/>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/products/Products.js